<article class="box">
  <header class="modal-header">
    <button
      type="button"
      class="close pull-right"
      title="{{ 'CLOSE' | translate }}"
      [attr.aria-label]="'CLOSE' | translate"
      (click)="hide('cancel')"
    ></button>
  </header>

  <section class="modal-body">
    <img src="assets/img/icons/appointment.svg" alt="appointment" />

    <div>
      <div class="title">
        {{
          'BATCH_MAILING.BATCHES_TAB.DETAILS_OF_SHIPMENT_CHANGED' | translate
        }}
      </div>

      <div class="sub-title">
        {{ 'BATCH_MAILING.BATCHES_TAB.NOT_DOWNLOADED_BLANK' | translate }}
      </div>
    </div>
  </section>

  <div class="modal-footer">
    <button class="button button--filled" (click)="hide('success')">
      {{ 'POPUP_OK' | translate }}
    </button>
  </div>
</article>
